import React, { useState, useEffect, Fragment } from "react"
import "./CoachProfileBox.scss"
import CoachProfileTile from "./CoachProfileTile/CoachProfileTile"
import { CoachDataApi } from "../../../services/CallApi"
import ApiURL from "../../../services/ApiURL"
import { ErrorUI } from "../../UI/Modals/Modals"
import VideoCarousel from "../VideoCarousel/VideoCarousel"

const CoachProfileBox = ({ gymIds, url, ...props }) => {
  const [coachList, updateCoachList] = useState([])

  useEffect(() => {
    getCoachesList(gymIds)
  }, [gymIds])

  const getCoachesList = (gymIds) => {
    const payload = {
      limit: 20,
      offset: 0,
      gym_ids: JSON.stringify(gymIds),
    }
    CoachDataApi(ApiURL[url], payload).then(async (res) => {
      if (res.status) {
        updateCoachList([...res.list])
      } else {
        ErrorUI(res.list, () => {
          getCoachesList(gymIds)
        })
      }
    })
  }

  const coachData = coachList.map((el) => (
    <CoachProfileTile key={el.user_id} {...el} />
  ))

  return coachData.length ? (
    <VideoCarousel heading="COACHES">{coachData}</VideoCarousel>
  ) : null
}

export default CoachProfileBox
